import { useEffect, useState } from 'react'
import styles from './Nav.module.css'
import ScrollContainer from '../ScrollContainer/ScrollContainer'
import { Link } from 'react-router-dom'

export default function Nav() {
  const [offset, setOffset] = useState(0)
  useEffect(() => {
    setOffset(window.topNavOffset)
  }, [])
  return (
    <nav className={styles.nav} style={{ top: offset }}>
      <ScrollContainer>
        <Link to="/agencies" className={styles.active}>
          Discover
        </Link>
        <Link to="/agencies/directory-modeling">Modeling & Talent Agencies</Link>
        <Link to="/agencies/directory-artists">Artists Agencies</Link>
        <Link to="/agencies/directory-services">Production & Creative Services</Link>
      </ScrollContainer>
    </nav>
  )
}
